import styled from 'styled-components';

export const LAST_ROW_SPACER_HEIGHT = 20;

const LastRowSpacer = styled.div`
  height: ${LAST_ROW_SPACER_HEIGHT}px;
  display: flex;
  flex: 1;
`;

export default LastRowSpacer;
